import { Role } from '../../../../types/auth';

type ReportingMenuItem = {
  title: string;
  path: string;
  permissions: Role[];
};

const ITEMS = (t: (key: string) => string): ReportingMenuItem[] => [
  {
    title: t('pages:reporting.historicalActions'),
    path: 'historical-actions',
    permissions: [Role.SuperAdmin, Role.Coex, Role.Capataz],
  },
  {
    title: t('pages:reporting.historicalAccidents'),
    path: 'historical-accidents',
    permissions: [Role.SuperAdmin, Role.Coex, Role.Capataz],
  },
  {
    title: t('pages:reporting.historicalGenericOrders'),
    path: 'historical-generic-orders',
    permissions: [Role.SuperAdmin, Role.Coex, Role.Capataz],
  },
  {
    title: t('pages:reporting.historicalCampaigns'),
    path: 'historical-campaigns',
    permissions: [Role.SuperAdmin, Role.Coex, Role.Capataz],
  },
  {
    title: t('pages:reporting.historicalCommunications'),
    path: 'historical-communications',
    permissions: [Role.SuperAdmin, Role.Coex, Role.Capataz, Role.RoomTeam],
  },
  {
    // Históricos de Recorrido de Vigilancia (reorg 2026-07-04, D11/FR-2.7:
    // supervisores sí, Tablet no). Debajo de Comunicaciones y con la
    // convención de nombres de Informes (decisión usuario 2026-07-04).
    title: t('pages:reporting.historicalRoutes'),
    path: 'search-create-historical-route',
    permissions: [Role.SuperAdmin, Role.Coex, Role.Capataz, Role.RoomTeam],
  },
  {
    title: t('pages:reporting.historicalBudgets'),
    path: 'historical-budgets',
    permissions: [Role.SuperAdmin, Role.Coex],
  },
  {
    title: t('pages:reporting.timeManagement'),
    path: 'time-management',
    permissions: [Role.SuperAdmin, Role.Coex, Role.Capataz],
  },
];

// Filtra los ítems del menú por el rol activo. Tablet solo ve Gestión Horaria.
// Sin rol (undefined) → todos, para no romper otros consumidores.
export const getData = (
  t: (key: string) => string,
  currentRole?: Role | null,
): ReportingMenuItem[] => {
  const items = ITEMS(t);
  if (!currentRole) return items;
  return items.filter((i) => i.permissions.includes(currentRole));
};

// Para compatibilidad con imports existentes - usar valores por defecto
export const data = [
  {
    title: 'Actuacions Históriques',
    path: 'historical-actions',
  },
  {
    title: 'Accidents Històrics',
    path: 'historical-accidents',
  },
  {
    title: 'Gestió Horària',
    path: 'time-management',
  },
];
